// Validates an email address against Salesforce's stricter rules.
//
// Support cases submitted through the help form are pushed to Salesforce by the
// supportal service. Salesforce rejects some addresses that are technically
// RFC-valid (and pass a basic regex / Yup's `.email()`), which causes an
// INVALIDEMAILADDRESS error and dead-letters the case-creation job in supportal.
//
// The known-bad shapes are all in the local part (before the "@"):
//   - starts with a dot         .user@example.com
//   - ends with a dot           user.@example.com
//   - has consecutive dots      user..name@example.com
//
// Catching these before the email is sent to supportal gives the customer an
// immediate error instead of a case that silently fails hours later.

const BASIC_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const isValidEmailForSalesforce = (email?: string | null): boolean => {
    if (!email) {
        return false;
    }

    const trimmed = email.trim();

    if (!BASIC_EMAIL_REGEX.test(trimmed)) {
        return false;
    }

    const localPart = trimmed.slice(0, trimmed.indexOf("@"));

    if (localPart.startsWith(".") || localPart.endsWith(".") || localPart.includes("..")) {
        return false;
    }

    return true;
};
